<div class="form-title-container" style="margin-top: 40px">
  <h3>Apoderados</h3>
  <button class="button add-button" (click)="store.openModal()">
    Añadir apoderado
  </button>
</div>

<div class="card" style="margin-bottom: 3rem">
  <app-clients-table
    [configTable]="store.tableConfig()"
    (openItemEvent)="store.openModal($event)"
    (deleteItemEvent)="deleteAttorney($event)"
    (executeActionEvent)="goToClientDetail($event)"
  >
  </app-clients-table>
</div>

<div class="modal" [ngClass]="{ 'is-active': store.isModalActive() }">
  <div class="modal-background" (click)="store.closeModal()"></div>
  <div class="modal-card">
    <form [formGroup]="store.attorniesForm" (submit)="saveAttorney()">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ store.isEditing() ? "Editar apoderado" : "Nuevo apoderado" }}
        </p>
        <button
          class="delete"
          aria-label="close"
          (click)="store.closeModal()"
        ></button>
      </header>

      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12 form-container">
            <span class="label">Cliente</span>
            <p-dropdown
              [options]="store.attornyOptions()"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              filterBy="name"
              placeholder="Buscar cliente"
              formControlName="associatedClient"
              [emptyFilterMessage]="'No se encontraron resultados'"
              appendTo="body"
            ></p-dropdown>
          </div>
          <div class="column is-12 form-container">
            <span class="label">Nombre</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="name"
            />
          </div>
          <div class="column is-12 form-container">
            <span class="label">NIF</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="nif"
            />
          </div>
          <div class="column is-12 form-container">
            <span class="label">Tipo de responsabilidad</span>
            <p-dropdown
              [options]="responsibilityOptions()"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccione tipo de responsabilidad"
              formControlName="responsibilityType"
              appendTo="body"
            ></p-dropdown>
          </div>
          @if (
            store.attorniesForm.get("responsibilityType")?.value ===
            "RESPONSIBILITY_ESPECIAL"
          ) {
            <div class="column is-12 form-container">
              <label class="label" for="attorney-special-summary">Resumen de poderes</label>
              <textarea
                id="attorney-special-summary"
                pInputTextarea
                class="search-input observations-field"
                formControlName="specialResponsibilitySummary"
                rows="4"
              ></textarea>
            </div>
          }

          <div class="column is-6 form-container">
            <span class="label">Fecha de alta del poder</span>
            <p-calendar
              formControlName="startDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              appendTo="body"
              placeholder="dd/mm/aaaa"
              class="search-input"
            ></p-calendar>
          </div>

          <div class="column is-6 form-container">
            <span class="label">Fecha de baja</span>
            <p-calendar
              formControlName="endDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              appendTo="body"
              placeholder="dd/mm/aaaa"
              class="search-input"
            ></p-calendar>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot buttons-container">
        <button
          class="button cancel-button"
          type="button"
          (click)="store.closeModal()"
        >
          Cancelar
        </button>
        <button class="button save-button" type="submit">Guardar</button>
      </footer>
    </form>
  </div>
</div>
